export const T = {
  en_GB: { title: "Embedded content" },
  nb_NO: { title: "Innebygd innhold" },
} as const;
